import axiosInstance from '@/core/api'

export class MessageService {
	static async buildPromotionFlex(dto: {
		promotionIds: string[]
		enableInstantClaim?: boolean
	}): Promise<{
		flexJson: any
		lineTransactionType: string
	} | null> {
		const { data } = await axiosInstance.post<{
			flexJson: any
			lineTransactionType: string
		} | null>('/admin/message/build-promotion-flex', dto)
		return data
	}
}
